// Flow types automatically removed

/* eslint-disable import/no-default-export */
import { DynamicInput } from './DynamicInput.jsx';
export default DynamicInput;
